// @flow

import {
  type Locale,
  locales as webpackLocales
} from 'railsRoot/config/webpack/availableLocales';
export type { Locale } from 'railsRoot/config/webpack/availableLocales';
export const locales: $ReadOnlyArray<Locale> = webpackLocales;

export opaque type Localizable<LocalizableValue> = {|
  locale: Locale,
  value: LocalizableValue
|};

export opaque type Localized<LocalizedValue>: LocalizedValue = LocalizedValue;

export function localizable<Value>(
  locale: Locale,
  value: Value
): Localizable<Value> {
  return {
    locale,
    value
  };
}

export function localize<Input, Output>(
  { locale, value }: Localizable<Input>,
  f: (Locale, Input) => Output
): Localized<Output> {
  return f(locale, value);
}
